import cn from "classnames";
import type { Icon } from "iconsax-react";

export interface TaxMainTab {
  id: string;
  label: string;
  icon: Icon;
}

interface Props {
  items: TaxMainTab[];
  activeId: string;
  onChange: (id: string) => void;
}

export default function TaxMainTabs({ items, activeId, onChange }: Props) {
  return (
    <div className="p-6 radius-3xl surface-base-fill flex flex-wrap justify-start items-center gap-2">
      {items.map(function renderTab(item) {
        const isActive = item.id === activeId;
        const TabIcon = item.icon;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            className={cn(
              "px-3 py-2.5 flex justify-start items-center gap-2 radius-sm text-label-md cursor-pointer",
              isActive ? "background-brand-fill text-white" : "surface-component-fill content-action-neutral",
            )}>
            <TabIcon size={20} color="currentColor" />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
